import styled from 'styled-components';
import {
  DropdownToggle,
  DropdownItem,
  Dropdown,
  DropdownMenu,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// styles
export const StyledDropdown = styled(Dropdown)`
  margin-left: 10px;
`;

export const StyledDropdownToggle = styled(DropdownToggle)`
  border: 1px solid #bec5d3 !important;
  background: white !important;
  color: black !important;
  box-shadow: none !important;

  &:hover {
    background: white;
  }
`;

export const DropdownMenuItem = styled(DropdownItem)`
  font-size: 12px;
  color: black;
`;

export const DropdownMenuItemIcon = styled.span`
  margin-right: 10px;
  width: 18px;
  display: inline-block;
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  margin-left: 8px;
  margin-right: 0 !important;
`;

export const StyledDropdownMenu = styled(DropdownMenu)`
  border: 1px solid #dfe3ec;
  box-shadow: 0 2px 8px #c8ccd5;
  transform: translate3d(-80px, 38px, 0px) !important;
`;
